import { XMLParser } from 'fast-xml-parser';

// Konfiguracje debugowania
// eslint-disable-next-line no-unused-vars
const DEBUG_MENU = true; // Dodatkowa flaga do debugowania samego menu

/**
 * Funkcja ekstrahująca elementy menu z pliku XML
 */
/*
const extractGlobalMenuItems = async (result) => {
  const menuItems = {
    priority: {},
    navigation: {}
  };

  try {
    // Debugowanie struktury XML dla menu
    if (DEBUG_MENU) {
      console.log('==== DEBUGOWANIE MENU ====');
      console.log('Sprawdzam strukturę result.offer:', result.offer ? 'Znaleziono' : 'Nie znaleziono');
      
      if (result.offer) {
        console.log('Dostępne elementy w result.offer:', Object.keys(result.offer));
        
        // Sprawdź priority_menu
        if (result.offer.priority_menu) {
          console.log('Struktura priority_menu:', result.offer.priority_menu);
        } else {
          console.log('Brak priority_menu w result.offer');
        }
        
        // Sprawdź navigation_menu
        if (result.offer.navigation_menu) {
          console.log('Struktura navigation_menu:', result.offer.navigation_menu);
        } else {
          console.log('Brak navigation_menu w result.offer');
        }
      }
    }

    // Przetwarzanie priority_menu
    if (result.offer && result.offer.priority_menu && result.offer.priority_menu.menu) {
      const priorityMenu = Array.isArray(result.offer.priority_menu.menu)
        ? result.offer.priority_menu.menu
        : [result.offer.priority_menu.menu];

      if (DEBUG_MENU) {
        console.log('Priority menu po konwersji na tablicę:', priorityMenu);
      }

      priorityMenu.forEach((menu, index) => {
        if (DEBUG_MENU) {
          console.log(`Analizuję element priority_menu[${index}]:`, menu);
        }
        
        if (menu && menu.site) {
          const sites = Array.isArray(menu.site) ? menu.site : [menu.site];
          
          if (DEBUG_MENU) {
            console.log(`Menu ${index} zawiera ${sites.length} elementów site`);
          }
          
          sites.forEach((site, siteIndex) => {
            if (DEBUG_MENU) {
              console.log(`Analizuję site[${siteIndex}]:`, site);
            }
            
            if (site.id && site.name) {
              menuItems.priority[site.id] = {
                id: site.id,
                name: site.name
              };
              
              if (DEBUG_MENU) {
                console.log(`Dodano element menu: ${site.id} - ${site.name}`);
              }
            } else {
              if (DEBUG_MENU) {
                console.log(`Site nie zawiera id lub name:`, site);
              }
            }
          });
        } else {
          if (DEBUG_MENU) {
            console.log(`Menu nie zawiera elementów site lub jest puste`);
          }
        }
      });
    } else {
      if (DEBUG_MENU) {
        console.log('Nie znaleziono prawidłowej struktury priority_menu');
      }
    }

    // Przetwarzanie navigation_menu
    if (result.offer && result.offer.navigation_menu && result.offer.navigation_menu.menu) {
      const navigationMenu = Array.isArray(result.offer.navigation_menu.menu)
        ? result.offer.navigation_menu.menu
        : [result.offer.navigation_menu.menu];

      if (DEBUG_MENU) {
        console.log('Navigation menu po konwersji na tablicę:', navigationMenu);
      }

      navigationMenu.forEach((menu, index) => {
        if (DEBUG_MENU) {
          console.log(`Analizuję element navigation_menu[${index}]:`, menu);
        }
        
        // Sprawdzamy oba możliwe formaty: bezpośrednie atrybuty lub elementy node
        if (menu.node_id && menu.node_name) {
          menuItems.navigation[menu.node_id] = {
            id: menu.node_id,
            name: menu.node_name
          };
          
          if (DEBUG_MENU) {
            console.log(`Dodano element menu nawigacyjnego bezpośrednio: ${menu.node_id} - ${menu.node_name}`);
          }
        } else if (menu.node) {
          // Możliwe, że nawigacja jest zagnieżdżona w elemencie node
          const nodes = Array.isArray(menu.node) ? menu.node : [menu.node];
          
          if (DEBUG_MENU) {
            console.log(`Menu ${index} zawiera ${nodes.length} elementów node`);
          }
          
          nodes.forEach((node, nodeIndex) => {
            if (DEBUG_MENU) {
              console.log(`Analizuję node[${nodeIndex}]:`, node);
            }
            
            if (node.id && node.name) {
              menuItems.navigation[node.id] = {
                id: node.id,
                name: node.name
              };
              
              if (DEBUG_MENU) {
                console.log(`Dodano element menu: ${node.id} - ${node.name}`);
              }
            } else {
              if (DEBUG_MENU) {
                console.log(`Node nie zawiera id lub name:`, node);
              }
            }
          });
        } else {
          if (DEBUG_MENU) {
            console.log(`Menu nawigacyjne nie zawiera elementów node lub jest puste`);
          }
        }
      });
    } else {
      if (DEBUG_MENU) {
        console.log('Nie znaleziono prawidłowej struktury navigation_menu');
      }
    }
    
    // Dodaję debugowanie dla menu
    if (DEBUG_MENU) {
      console.log('==== WYNIKI EKSTRAKCJI MENU ====');
      console.log('Elementy menu priorytetowego:', Object.keys(menuItems.priority).length);
      console.log('Elementy menu nawigacyjnego:', Object.keys(menuItems.navigation).length);
      console.log('Szczegóły menu priorytetowego:', menuItems.priority);
      console.log('Szczegóły menu nawigacyjnego:', menuItems.navigation);
    }
  } catch (error) {
    console.error('Błąd podczas ekstrakcji elementów menu:', error);
  }

  return menuItems;
};
*/

// Funkcja do normalizacji ścieżek węzłów
const normalizeNodePath = (path) => {
  if (!path) return path;
  
  // Najpierw zapisujemy oryginalną wersję
  const original = path;
  
  // Zastępujemy podwójne ukośniki pojedynczymi
  let normalized = path.replace(/\\\\/g, '\\');
  
  // Usuwamy nadmiarowe spacje na początku i końcu
  normalized = normalized.trim();
  
  // Dodatkowe warianty normalizacji
  // W niektórych implementacjach XML podwójne ukośniki mogą być zamieniane na pojedyncze slash (/)
  if (normalized.includes('/')) {
    normalized = normalized.replace(/\//g, '\\');
  }
  
  // Upewniamy się, że używamy prawidłowego formatu ukośników
  if (normalized.includes('\\\\')) {
    normalized = normalized.replace(/\\\\/g, '\\');
  }
  
  console.log(`DEBUG Normalizacja ścieżki: "${original}" -> "${normalized}"`);
  
  return normalized;
};

/**
 * Ekstrahuje elementy menu dla pojedynczego produktu
 */
const extractMenuItems = (product) => {
  try {
    // Pobieramy elementy nawigacji
    const navigation = product['iaiext:navigation'];
    const navigationItems = navigation?.['iaiext:site']?.['iaiext:menu']?.[0]?.['iaiext:item'] || [];
    
    // Pobieramy elementy menu priorytetowego
    const priorityMenuItems = product['iaiext:priority_menu']?.site?.[0]?.menu?.[0]?.item || [];
    
    // Debugowanie dla wszystkich produktów
    console.log(`DEBUG MenuItems dla produktu ${product.id}:`);
    console.log('Liczba elementów nawigacji:', navigationItems.length);
    console.log('Liczba elementów menu priorytetowego:', priorityMenuItems.length);
    
    // Tworzymy mapę priorytetów
    const priorityMap = new Map();
    const nodeIdMap = new Map();
    
    priorityMenuItems.forEach(item => {
      // Pobieramy textId i level
      const textId = item.textId || item.textid || '';
      
      // Normalizujemy format ścieżki - zamieniamy podwójne ukośniki na pojedyncze
      const normalizedTextId = normalizeNodePath(textId);
      
      // Debugowanie priorytetów
      console.log(`DEBUG Priority Item dla produktu ${product.id}: TextID: ${textId} -> Normalizowane: ${normalizedTextId}`);
      
      const level = parseInt(item.level) || 930;
      
      // Pobieramy ID węzła menu
      const nodeId = parseInt(item.id || 0);
      
      // Zapisujemy priorytet i ID węzła do map
      priorityMap.set(normalizedTextId, level);
      if (nodeId > 0) {
        nodeIdMap.set(normalizedTextId, nodeId);
      }
    });
    
    // Tworzymy również mapę nodeId z navigationItems dla węzłów głównych
    // które mogą nie być w priorityMenuItems
    const navigationNodeIdMap = new Map();
    navigationItems.forEach(item => {
      const textIdOriginal = item.textid || item.textId || '';
      const normalizedTextId = normalizeNodePath(textIdOriginal);
      const nodeId = parseInt(item.id || item.nodeId || 0);
      
      if (nodeId > 0 && normalizedTextId) {
        navigationNodeIdMap.set(normalizedTextId, nodeId);
        console.log(`DEBUG Navigation NodeId dla produktu ${product.id}: "${normalizedTextId}" -> ID: ${nodeId}`);
      }
    });
    
    // Przetwarzamy elementy nawigacji
    const menuItems = navigationItems
      .filter(item => item.textid || item.textId)
      .map(item => {
        const textIdOriginal = item.textid || item.textId;
        
        // Normalizujemy format ścieżki - zamieniamy podwójne ukośniki na pojedyncze
        const normalizedTextId = normalizeNodePath(textIdOriginal);
        
        // Pobieramy nodeId z navigationItem (może być dostępne dla węzłów głównych)
        const navigationItemNodeId = parseInt(item.id || item.nodeId || 0);
        
        console.log(`DEBUG Navigation Item dla produktu ${product.id}: TextID: ${textIdOriginal} -> Normalizowane: ${normalizedTextId}, NodeId: ${navigationItemNodeId}`);
        
        // Dzielimy ścieżkę na części używając znormalizowanej wersji
        const pathParts = normalizedTextId.split('\\');
        const items = [];
        
        let currentPath = '';
        pathParts.forEach((part, index) => {
          // Budujemy ścieżkę krok po kroku
          currentPath = currentPath ? `${currentPath}\\${part}` : part;
          // Dodatkowo normalizujemy każdą częściową ścieżkę
          currentPath = normalizeNodePath(currentPath);
          
          // Sprawdzamy, czy dla tej ścieżki mamy priorytet
          const priority = priorityMap.get(currentPath);
          
          // PRIORYTET 1: nodeId z priorityMenuItems (najbardziej wiarygodne)
          // PRIORYTET 2: nodeId z navigationNodeIdMap (dla węzłów głównych)
          // PRIORYTET 3: nodeId z bieżącego navigationItem (jeśli ścieżka się zgadza)
          // PRIORYTET 4: 0 (fallback)
          let nodeId = nodeIdMap.get(currentPath);
          
          if (!nodeId || nodeId === 0) {
            // Sprawdź w navigationNodeIdMap
            nodeId = navigationNodeIdMap.get(currentPath);
          }
          
          if (!nodeId || nodeId === 0) {
            // Jeśli currentPath jest dokładnie taki sam jak normalizedTextId, użyj nodeId z navigationItem
            if (currentPath === normalizedTextId && navigationItemNodeId > 0) {
              nodeId = navigationItemNodeId;
            }
          }
          
          // Dodajemy element do listy
          items.push({
            textId: currentPath,
            name: part, // Używamy tylko bieżącej części jako nazwa dla czytelności
            level: priority !== undefined ? priority : 930,
            nodeId: nodeId || 0
          });
        
          console.log(`DEBUG Utworzona ścieżka dla produktu ${product.id}: ${currentPath}, Level: ${priority !== undefined ? priority : 930}, NodeId: ${nodeId || 0}`);
        });
        
        return items;
      })
      .flat()
      .filter((item, index, self) => 
        index === self.findIndex(t => t.textId === item.textId)
      );
    
    // Wypisujemy wszystkie unikalne węzły
    const uniqueNodes = new Set(menuItems.map(item => item.textId));
    console.log(`DEBUG: Produkt ${product.id} ma następujące unikalne węzły (${uniqueNodes.size}):`);
    [...uniqueNodes].sort().forEach(node => {
      console.log(`- "${node}"`);
    });
    
    // Sprawdzamy, czy mamy węzeł "SKLEP\Marynarki"
    const marynarkiNode = menuItems.find(item => 
      item.textId === 'SKLEP\\Marynarki' || 
      item.textId === 'SKLEP\\MARYNARKI' || 
      item.textId === 'SKLEP/Marynarki' || 
      item.textId.toLowerCase().includes('marynark')
    );
    
    if (marynarkiNode) {
      console.log(`DEBUG: Produkt ${product.id} ma węzeł Marynarki: "${marynarkiNode.textId}" (level: ${marynarkiNode.level})`);
    }
    
    // Dodatkowy krok - upewniamy się, że wszystkie węzły są znormalizowane
    const normalizedMenuItems = menuItems.map(item => ({
      ...item,
      textId: normalizeNodePath(item.textId)
    }));
    
    return normalizedMenuItems;
  } catch (error) {
    console.error('Błąd podczas ekstrakcji menu items:', error);
    return [];
  }
};

/**
 * Parsuje plik XML i zwraca przetworzone dane
 */
export const parseXMLFile = async (source, isText = false) => {
  try {
    let xmlText;
    if (isText) {
      xmlText = source;
    } else {
      const response = await fetch(source);
      xmlText = await response.text();
    }

    const options = {
      attributeNamePrefix: "",
      ignoreAttributes: false,
      allowBooleanAttributes: true,
      parseAttributeValue: true,
      trimValues: true,
      processEntities: false,
      isArray: (name, jpath) => {
        // Upewniamy się, że te elementy zawsze będą tablicami
        if (['product', 'iaiext:item', 'item', 'size'].includes(name)) return true;
        // Grupy powinny być dostępne jako pojedynczy element, a nie tablica
        if (name === 'group') return false;
        // Wymuszamy tablicę dla menu w priority_menu
        if (name === 'menu' && jpath.includes('priority_menu')) return true;
        // Wymuszamy tablicę dla site w priority_menu
        if (name === 'site' && jpath.includes('priority_menu')) return true;
        return false;
      }
    };

    const parser = new XMLParser(options);
    const result = parser.parse(xmlText);

    console.log('Parsed XML structure:', result.offer ? 'Znaleziono offer' : 'Nie znaleziono offer');

    if (!result?.offer?.products?.product) {
      throw new Error('Nieprawidłowa struktura pliku XML');
    }

    // Analizujemy strukturę pierwszego produktu
    if (result.offer.products.product.length > 0) {
      console.log('DEBUG: Struktura przykładowego produktu:');
      const firstProduct = result.offer.products.product[0];
      console.log(JSON.stringify(firstProduct, null, 2));
    }

    // Dodajemy diagnostykę grup produktów przed filtrowaniem
    debugProductGroups(result.offer.products.product);

    const products = result.offer.products.product
      // Filtrujemy produkty po widoczności
      .filter(product => {
        console.log(`DEBUG Produkt ID ${product.id} - Debugowanie atrybutów:`, {
          visibility: product['iaiext:visibility']?.['iaiext:site']?.visible,
          available: product['@_iaiext:available'],
          iaiextAvailable: product['iaiext:available'],
          keys: Object.keys(product)
        });
        
        // Sprawdzamy oba warunki - widoczność i dostępność
        const isVisible = product['iaiext:visibility']?.['iaiext:site']?.visible === 'yes' && 
                         product['iaiext:available'] === 'yes';
        return isVisible;
      })
      .map(product => {
        const menuItems = extractMenuItems(product);
        
        // Obsługa różnych formatów nazwy produktu
        let productName = product.name;
        
        // Jeśli name jest tablicą (różne języki), wybierz polski
        if (Array.isArray(productName)) {
          const polishName = productName.find(n => n['xml:lang'] === 'pol');
          productName = polishName?.['#text'] || polishName || productName[0];
        }
        
        // Jeśli name jest obiektem z różnymi atrybutami
        if (typeof productName === 'object' && productName !== null) {
          // Spróbuj znaleźć polski lub użyj pierwszej dostępnej wartości
          if (productName['#text']) {
            productName = productName['#text'];
          } else if (productName['xml:lang']) {
            // To jest pojedynczy obiekt z językiem
            productName = productName['#text'] || 'Brak nazwy';
          } else {
            // Jeśli to obiekt z kluczami języków
            productName = productName['pol'] || productName['eng'] || Object.values(productName)[0] || 'Brak nazwy';
          }
        }
        
        // Obsługa description.name jeśli product.name nie istnieje
        if (!productName && product.description?.name) {
          const descName = product.description.name;
          if (Array.isArray(descName)) {
            const polishName = descName.find(n => n['xml:lang'] === 'pol');
            productName = polishName?.['#text'] || polishName || descName[0]?.['#text'] || descName[0];
          } else if (typeof descName === 'object') {
            productName = descName['#text'] || descName;
          } else {
            productName = descName;
          }
        }
        
        // Obsługa gdy name ma atrybut type="name"
        if (!productName || typeof productName === 'object') {
          const nameWithType = product.description?.name;
          if (nameWithType && typeof nameWithType === 'object' && nameWithType.type === 'name') {
            productName = nameWithType['#text'] || 'Brak nazwy';
          }
        }
        
        // Obsługa różnych formatów URL ikony
        let iconUrl = null;
        
        if (product.images?.icons?.icon) {
          const icon = product.images.icons.icon;
          
          // Jeśli icon jest tablicą, weź pierwszy element
          if (Array.isArray(icon)) {
            iconUrl = icon[0]?.url || null;
          } else {
            iconUrl = icon.url || null;
          }
        }
        
        return {
          id: product.id,
          name: productName || `Produkt ${product.id}`,
          iconUrl: iconUrl,
          codeOnCard: product.code_on_card,
          menuItems: menuItems,
          originalData: product
        };
      })
      .filter(product => product.menuItems.length > 0);

    console.log(`Znaleziono ${products.length} produktów`);

    // Dodajemy diagnostykę grup po przetworzeniu produktów
    debugProcessedProductGroups(products);

    // Zbieramy unikalne węzły menu
    const menuNodes = [...new Set(
      products.flatMap(p => p.menuItems.map(i => i.textId))
    )].filter(Boolean).sort();

    console.log(`Znaleziono ${menuNodes.length} węzłów menu`);
    
    // Dodajemy wydruk węzłów menu, aby można było sprawdzić ich format
    console.log('Dostępne węzły menu:');
    menuNodes.forEach(node => {
      console.log(`- "${node}"`);
    });

    return { products, menuNodes };
  } catch (error) {
    console.error('Błąd podczas parsowania XML:', error);
    throw error;
  }
};

/**
 * Funkcja diagnostyczna do analizy grup produktów w oryginalnym XML
 */
function debugProductGroups(products) {
  console.log('==== DIAGNOSTYKA GRUP PRODUKTÓW W XML ====');
  
  // Licznik produktów z grupami
  let productsWithGroups = 0;
  let totalGroups = 0;
  
  // Mapa grup do śledzenia, które produkty są w grupach
  const groupsMap = new Map();
  
  // Licznik grup z trybem select_product
  let selectProductGroups = 0;
  
  products.forEach(product => {
    // Sprawdzamy czy produkt ma grupę (pojedynczy element <group>, a nie tablica groups)
    if (product.group) {
      productsWithGroups++;
      totalGroups++;
      
      console.log(`\nProdukt ID: ${product.id}, Nazwa: ${product.name || 'brak nazwy'}`);
      console.log(`Produkt posiada grupę`);
      
      const group = product.group;
      console.log(`  Grupa: ${JSON.stringify(group)}`);
      
      // Poprawiona ścieżka do ustawień wyświetlania
      const displaySettings = group["iaiext:products_display_settings"];
      if (displaySettings && displaySettings["iaiext:show_in_store"]) {
        const showInStore = displaySettings["iaiext:show_in_store"];
        console.log(`    Tryb wyświetlania: ${showInStore.value}`);
        
        if ((showInStore.value === 'select_product' || showInStore.value === 'first_product') && showInStore.product_id) {
          console.log(`    Wybrany produkt: ${showInStore.product_id}`);
          selectProductGroups++;
        }
      } else {
        console.log('    Brak ustawień wyświetlania w grupie');
      }
      
      // Generujemy unikalny identyfikator grupy, jeśli nie ma jawnego ID
      const groupId = group.id || `auto_group_${totalGroups}`;
      
      // Śledzimy grupę w mapie
      if (!groupsMap.has(groupId)) {
        groupsMap.set(groupId, {
          productIds: [],
          showInStore: displaySettings?.["iaiext:show_in_store"]
        });
      }
      groupsMap.get(groupId).productIds.push(product.id);
    }
  });
  
  console.log('\n==== PODSUMOWANIE GRUP ====');
  console.log(`Łączna liczba produktów z grupami: ${productsWithGroups} z ${products.length} (${Math.round(productsWithGroups/products.length*100)}%)`);
  console.log(`Liczba unikalnych grup: ${groupsMap.size}`);
  console.log(`Liczba grup z trybem select_product: ${selectProductGroups}`);
  
  // Analizujemy grupy, które mają tryb "select_product"
  groupsMap.forEach((groupInfo, groupId) => {
    const showInStore = groupInfo.showInStore;
    if (showInStore && showInStore.value === 'select_product') {
      console.log(`\nGrupa ${groupId} ma tryb select_product`);
      console.log(`  Liczba produktów w grupie: ${groupInfo.productIds.length}`);
      console.log(`  Wybrany produkt: ${showInStore.product_id}`);
      console.log(`  Produkty w grupie: ${groupInfo.productIds.join(', ')}`);
    }
  });
}

/**
 * Funkcja pomocnicza do znalezienia produktu po ID grupy
 */
function findProductByGroupId(products, groupId) {
  for (const product of products) {
    if (product.group) {
      const currentGroupId = product.group.id || `auto_group_${product.id}`;
      if (currentGroupId === groupId) {
        return product;
      }
    }
  }
  return null;
}

/**
 * Funkcja diagnostyczna do analizy grup produktów po przetworzeniu
 */
function debugProcessedProductGroups(products) {
  console.log('\n==== DIAGNOSTYKA PRZETWORZONYCH GRUP PRODUKTÓW ====');
  
  // Licznik produktów z grupami
  let productsWithGroups = 0;
  // Licznik produktów w grupach z trybem select_product
  let productsInSelectProductGroups = 0;
  
  products.forEach(product => {
    // Sprawdzamy czy produkt ma oryginalne dane i grupę
    if (product.originalData && product.originalData.group) {
      productsWithGroups++;
      
      console.log(`\nPrzetworzony produkt ID: ${product.id}, Nazwa: ${product.name || 'brak nazwy'}`);
      
      const group = product.originalData.group;
      console.log(`  Grupa: ${JSON.stringify(group)}`);
      
      // Poprawiona ścieżka do ustawień wyświetlania
      const displaySettings = group["iaiext:products_display_settings"];
      if (displaySettings && displaySettings["iaiext:show_in_store"]) {
        const showInStore = displaySettings["iaiext:show_in_store"];
        console.log(`    Tryb wyświetlania: ${showInStore.value}`);
        
        if (showInStore.value === 'select_product' && showInStore.product_id) {
          console.log(`    Wybrany produkt: ${showInStore.product_id}`);
          productsInSelectProductGroups++;
          
          // Sprawdzamy czy to jest ten sam produkt
          if (showInStore.product_id === product.id) {
            console.log(`    UWAGA: To jest wybrany produkt do wyświetlania!`);
          } else {
            console.log(`    UWAGA: Ten produkt powinien zostać ukryty!`);
          }
        }
      } else {
        console.log(`    Brak ustawień wyświetlania w grupie`);
      }
    }
  });
  
  console.log(`\nLiczba przetworzonych produktów z grupami: ${productsWithGroups} z ${products.length} (${Math.round(productsWithGroups/products.length*100)}%)`);
  console.log(`Liczba produktów w grupach z trybem select_product: ${productsInSelectProductGroups}`);
}

export default parseXMLFile; 